import { __decorate } from "tslib";
import { property, customElement } from 'lit/decorators.js';
import { LitElement, html } from 'lit';
import { textStyles } from './styles';
let LitText = class LitText extends LitElement {
    constructor() {
        super(...arguments);
        this.center = false;
        this.pulse = false;
        this.status = 'none';
    }
    render() {
        return html `<slot></slot>`;
    }
};
LitText.styles = textStyles;
__decorate([
    property({ type: Boolean, attribute: true, reflect: true })
], LitText.prototype, "center", void 0);
__decorate([
    property({ type: Boolean, attribute: true, reflect: true })
], LitText.prototype, "pulse", void 0);
__decorate([
    property({ type: String, attribute: true, reflect: true })
], LitText.prototype, "status", void 0);
LitText = __decorate([
    customElement('lit-text')
], LitText);
export { LitText };
